export class JobInfoDTO {
  isError: boolean;
  typeCode: string;
  materialNumber: string;
  phCode: string;
  jobId: string;
  processingUtcTime: string;
  status: string;
  titleEdzLink: string;
  hrefEdzLink: string;
  titlePdfLink: string;
  hrefPdfLink: string;
  hrefOutput: string;

  constructor(obj: Partial<JobInfoDTO>) {
    // assign inputs
    this.isError = false;
    this.typeCode = obj.typeCode ?? '';
    this.materialNumber = obj.materialNumber ?? '';
    this.phCode = obj.phCode ?? '';
    this.jobId = obj.jobId ?? '';
    this.processingUtcTime = obj.processingUtcTime ?? '';
    this.status = obj.status ?? '';
    this.titleEdzLink = obj.titleEdzLink ?? '';
    this.hrefEdzLink = obj.hrefEdzLink ?? '';
    this.titlePdfLink = obj.titlePdfLink ?? '';
    this.hrefPdfLink = obj.hrefPdfLink ?? '';
    this.hrefOutput = obj.hrefOutput ?? '';
  }
}


